import ButtonPill from "../../Buttons/ButtonPill";
import IconAccepted from "../../../Assets/SVGs/Icons/YesOrNo/Accepted";

const Donate = () => {
    return (
        <div className="layout layout--donate">
            <div className="layout__header">
                {IconAccepted()}

                <h3>
                    Your support fuels uncensored truth.
                </h3>
            </div>

            <ButtonPill
                label="Donate to Ickonic"
                link="https://buy.stripe.com/3cs01y5WPgbOcJW145"
                openInNewWindow={true}
            />
        </div>
    )
}

export default Donate;
